// extracted by mini-css-extract-plugin
export default {"chooseImageBox":"ChooseImageUploadBox_chooseImageBox__xPkJO","input":"ChooseImageUploadBox_input__mXXMW","isDisabled":"ChooseImageUploadBox_isDisabled__xvhsY"};